import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {EquipeListPage} from './EquipeListPage'
import {EquipePage} from './EquipePage'
import HorairePage from './HorairePage'

const EquipeWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Paramètres',
                    path: '#',
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
              >
                Equipes
              </PageTitle>
              <EquipeListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Equipes', path: '/equipes', isSeparator: false, isActive: true},
                ]}
              >
                Création
              </PageTitle>
              <EquipePage />
            </>
          }
        />
        <Route
          path='/:equipeId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Equipes', path: '/equipes', isSeparator: false, isActive: true},
                ]}
              >
                Modification
              </PageTitle>
              <EquipePage />
            </>
          }
        />
        <Route
          path='/horaire/configurer'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Equipes', path: '/equipes', isSeparator: false, isActive: true},
                ]}
              >
                Création d'horaire
              </PageTitle>
              <HorairePage />
            </>
          }
        />
        <Route
          path='/horaire/:equipeId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Equipes', path: '/equipes', isSeparator: false, isActive: true},
                ]}
              >
                Modification d'horaire
              </PageTitle>
              <HorairePage />
            </>
          }
        />
        <Route index element={<Navigate to='/equipes/liste' />} />
      </Routes>
    </>
  )
}

export {EquipeWrapper}
